import gql from 'graphql-tag';
import { MarketingParticipantFragment } from '../fragments/marketing.capaign.participant.fragment'
import { PageFragment } from '../fragments/page.fragment';

export const GET_MARKETING_PARTICIPANTS = gql`
    query (
        $paging: CursorPaging
        $filter: MarketingCampaignParticipantFilter
        $sorting: [MarketingCampaignParticipantSort!]
    ) {
        marketingCampaignParticipants (
            paging: $paging
            filter: $filter
            sorting: $sorting
        ) {
            totalCount
            pageInfo {
                ...Page
            }
            edges {
                node {
                    ...MarketingCampaignParticipant
                }
            }
        }
    }
    ${MarketingParticipantFragment}
    ${PageFragment}
`;